export default {
  'pages.common.save': 'ذخیره',
  'pages.common.cancel': 'لغو',
  'pages.common.confirm': 'تأیید',
  'pages.common.ok': 'تأیید',
  'pages.common.delete': 'حذف',
  'pages.common.edit': 'ویرایش',
  'pages.common.add': 'افزودن',
  'pages.common.append': 'افزودن',
  'pages.common.search': 'جستجو',
  'pages.common.reset': 'بازنشانی',
  'pages.common.submit': 'ارسال',
  'pages.common.back': 'بازگشت',
  'pages.common.close': 'بستن',
  'pages.common.export': 'خروجی',
  'pages.common.import': 'ورودی',
  'pages.common.refresh': 'به‌روزرسانی',
  'pages.common.detail': 'جزئیات',
  'pages.common.copy': 'کپی',
  'pages.common.operation': 'عملیات',
  'pages.common.view': 'مشاهده',
  'pages.common.download': 'دانلود',
  'pages.common.upload': 'بارگذاری',
  'pages.common.yes': 'بله',
  'pages.common.no': 'خیر',
  'pages.common.loading': 'در حال بارگذاری…',
  'pages.common.more': 'بیشتر',
  'pages.common.all': 'همه',
  'pages.common.createSuccess': 'با موفقیت ایجاد شد',
  'pages.common.saveSuccess': 'ذخیره شد',
  'pages.common.deleteSuccess': 'حذف شد',
  'pages.common.deleteFailed': 'حذف ناموفق بود',
  'pages.common.saveFailed': 'ذخیره ناموفق بود',
  'pages.common.loadFailed': 'بارگذاری ناموفق بود',
  'pages.common.requiredField': 'این فیلد الزامی است',
  'pages.common.selectedCount': '{count} مورد انتخاب شد',
  'pages.common.clearSelection': 'پاک کردن انتخاب',
  'pages.common.totalRecords': 'مجموعاً {total} رکورد',
  'pages.common.batchDeleteCount': 'حذف دسته‌ای ({count})',
  'pages.common.statusSuccess': 'موفق',
  'pages.common.statusFailed': 'ناموفق',
  'pages.common.timeRangeStart': 'زمان شروع',
  'pages.common.timeRangeEnd': 'زمان پایان',
  'pages.common.unnamed': 'بدون نام',
  'pages.common.operationFailedRetry': 'عملیات ناموفق بود. دوباره تلاش کنید.',
  'pages.common.batchDeleteSuccess': 'حذف دسته‌ای انجام شد',
  'pages.common.batchDeleteFailed': 'حذف دسته‌ای ناموفق بود. دوباره تلاش کنید.',
  'pages.common.nItemsFailed': '{count} مورد ناموفق',
  'pages.common.enable': 'Enable',
  'pages.common.disable': 'Disable',
  'pages.common.statusNormal': 'Active',
  'pages.common.statusDisabled': 'Disabled',
  'pages.common.selectOrganization': 'Select organization',
  'pages.common.batchDeleteTitle': 'Confirm batch delete',
  'pages.common.downloadingTemplate': 'Downloading template…',
  'pages.common.templateDownloadSuccess': 'Template downloaded',
  'pages.common.templateDownloadFailed': 'Download failed. Please try again.',
};
